import $ from 'jquery';

(() => {
  const $person = $('.Person-content img, .Person-content .js-name, .Person-content .js-title');
  const $descBox = $('.TabsContent-description');
  // eslint-disable-next-line
  let currentPerson = [];

  function showPerson(personElement) {
    const currentImg = personElement.find('img').attr('src');
    const currentName = personElement.find('.js-name').text();
    const currentTitle = personElement.find('.js-title').text();
    const currentDesc = personElement.find('.js-description').html();
    const currentSocial = personElement.find('.js-social').html();

    // change content for current person in Description box
    $descBox.find('img').attr('src', currentImg);
    $descBox.find('.js-DescName').text(currentName);
    $descBox.find('.js-DescTitle').text(currentTitle);
    $descBox.find('.js-DescText').html(currentDesc);
    $descBox.find('.js-Social').html(currentSocial);

    currentPerson = personElement[0];
  }

  function choosePerson(e) {
    e.preventDefault();
    $descBox.addClass('is-open');
    showPerson($(this).closest('.Person-content'));
  }

  function init() {
    $person.on('click', choosePerson);
  }

  $(document).on('ready', init);
})();
